import SessionService from '@/bundles/Session/services/SessionService.ts';
import { http } from '@/bundles/Http/factory/HttpFactory';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';

function sessionServiceFactory() {
  return new SessionService(http, new ErrorMapper());
}

export const sessionService = sessionServiceFactory();
